import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { viewAbandonOrdersAction } from '../../actions';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

function AbandonOrdersView({ viewAbandonOrdersAction }) {
    const [abandonOrdersData, setAbandonOrdersData] = useState(null);
    const params = useParams();
    const id = params.id;

    useEffect(() => {
        viewAbandonOrdersAction({ id: id }, (err, response) => {
            if (!err) {
                setAbandonOrdersData(response.data.data);
            }
        });
    }, [id, viewAbandonOrdersAction]);

    return (
        <div className="col-lg-12">
            <div className="card">
                {
                    abandonOrdersData ?
                        <>
                            <div className="header d-flex justify-content-between align-items-center">
                                <h2>
                                    {abandonOrdersData.title}
                                </h2>
                            </div>
                            <div className="body table-responsive">
                                <table className="table table-hover">
                                    <tbody>
                                        <tr>
                                            <th>Full Name:</th>
                                            <td>{abandonOrdersData.fullname}</td>

                                        </tr>
                                        <tr>
                                            <th>Email:</th>
                                            <td>{abandonOrdersData.email}</td>

                                        </tr>
                                        <tr>
                                            <th>Phone:</th>
                                            <td>{abandonOrdersData.phone}</td>

                                        </tr>
                                        <tr>
                                            <th>Category:</th>
                                            <td>{abandonOrdersData.categoryId && abandonOrdersData.categoryId.title}</td>

                                        </tr>
                                        <tr>
                                            <th>Postcode:</th>
                                            <td>{abandonOrdersData.postcode}</td>

                                        </tr>
                                        <tr>
                                            <th>Address:</th>
                                            <td>{abandonOrdersData.address}</td>
                                        </tr>
                                        <tr>
                                            <th>Location:</th>
                                            <td>
                                            {abandonOrdersData.latitude}
                                            <br/>
                                            {abandonOrdersData.longitude}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Created At:</th>
                                            <td>{moment(abandonOrdersData.createdAt).format('YYYY-MM-DD hh:mm a')}</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </> :
                        <div className="text-center">
                            <Loader
                                type="Bars"
                                color="#00BFFF"
                                height={100}
                                width={100}
                                timeout={3000} //3 secs
                            />
                        </div>

                }

            </div>
        </div>
    )
}

export default connect(null, { viewAbandonOrdersAction })(AbandonOrdersView)